function BasicInput ({ className, label, name, ...props }) {
    return (
        <div className={className}>
            <label htmlFor={name}>{label}</label>
            <input autoComplete="off" id={name} name={name} {...props} />
        </div>
    )
}

export {
    BasicInput,
}